import fileSaver from 'file-saver'
import { IFiltersLamenessTable } from 'models'

import { useEffect, useState } from 'react'
import CattlesApiService from 'services/cattlesApiServices'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

interface IExportFatnessReportProps {
	page: number
	activeFilter?: any
	initialPageSize: number
	fatnessPoint?: number[]
	params?: IFiltersLamenessTable
}

const useExportFatnessReport = ({
	page,
	activeFilter,
	initialPageSize,
	fatnessPoint,
	params,
}: IExportFatnessReportProps) => {
	const dispatch = useAppDispatch()
	const [isFetchReport, setIsFetchReport] = useState(false)

	useEffect(() => {
		if (!isFetchReport) return

		CattlesApiService.getExportFatnessReport(
			activeFilter === 'all' || !activeFilter ? null : activeFilter,
			fatnessPoint,
			page,
			initialPageSize,
			params,
		)
			.then(response => {
				const blob = new Blob([response.data], {
					type: response.headers['content-type'],
				})
				fileSaver.saveAs(blob, 'fatness-report.xlsx')
			})
			.catch(error => {
				dispatch(
					notifyUser({
						title: 'Генерация отчёта завершилась с ошибкой',
						description: error.message,
						isError: true,
					}),
				)
			})
			.finally(() => {
				setIsFetchReport(false)
			})
	}, [
		isFetchReport,
		page,
		activeFilter,
		initialPageSize,
		fatnessPoint,
		params,
		dispatch,
	])

	return { isFetchReport, setIsFetchReport }
}

export default useExportFatnessReport
